// @flow strict
/* eslint-disable ta-code-conventions/has-matching-test */
import React, { useCallback } from 'react';
import Icon from '@ta/core-ui.icon';
import { useLocalize } from '@ta/platform.i18n';
import styles from './NearbyLink.css';

/**
 * @return a callback to prompt for location permissions and redirect to a nearby-scoped URL
 */
const useNearbyRedirect = () => {
  const { localize } = useLocalize();

  const redirectNearby = useCallback(() => {
    navigator.geolocation.getCurrentPosition(
      response => {
        const params = new URLSearchParams({
          isNearby: 'true',
          latitude: String(response.coords.latitude),
          longitude: String(response.coords.longitude),
        });

        // In the future we might want to be smarter about scoping to something related to the
        // current page, but there isn't a good univeral way of supporting that on all pages.
        // eslint-disable-next-line no-restricted-globals
        window.location = `/Home?${params.toString()}`;
      },
      error => {
        if (error.code === error.PERMISSION_DENIED) {
          /* eslint-disable no-alert */
          // TripAdvisor was denied permission to access your location.  Give your browser and TripAdvisor permission to use your current location and try again.
          alert(localize.string('mw_js_positionPermissionDenied'));
          /* eslint-enable no-alert */
        }
      },
    );
  }, [localize]);

  return redirectNearby;
};

/**
 * A link to a scoped page for the user's latitude and longitude
 */
const NearbyLink = () => {
  const { localize } = useLocalize();
  const redirectNearby = useNearbyRedirect();

  return (
    <button type="button" className={styles.nearbyLink} onClick={redirectNearby}>
      <div className={styles.icon}>
        <Icon name="nearby-fill" />
      </div>
      <div className={styles.text}>{localize('mx_nearby') /* Nearby */}</div>
    </button>
  );
};

export default NearbyLink;
